var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlocks(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    id: 1235,
    d: "M2.75 2C2.33579 2 2 2.33579 2 2.75V8.13462C2 8.54883 2.33579 8.88462 2.75 8.88462H8.13462C8.54883 8.88462 8.88462 8.54883 8.88462 8.13462V2.75C8.88462 2.33579 8.54883 2 8.13462 2H2.75ZM3.5 7.38462V3.5H7.38462V7.38462H3.5ZM11.3654 2C10.9512 2 10.6154 2.33579 10.6154 2.75V8.13462C10.6154 8.54883 10.9512 8.88462 11.3654 8.88462H16.75C17.1642 8.88462 17.5 8.54883 17.5 8.13462V2.75C17.5 2.33579 17.1642 2 16.75 2H11.3654ZM12.1154 7.38462V3.5H16V7.38462H12.1154ZM2.75 10.6154C2.33579 10.6154 2 10.9512 2 11.3654V16.75C2 17.1642 2.33579 17.5 2.75 17.5H8.13462C8.54883 17.5 8.88462 17.1642 8.88462 16.75V11.3654C8.88462 10.9512 8.54883 10.6154 8.13462 10.6154H2.75ZM3.5 16V12.1154H7.38462V16H3.5ZM14.0989 10.6C14.5131 10.6 14.8489 10.9358 14.8489 11.35V13.3092H16.7331C17.1474 13.3092 17.4831 13.645 17.4831 14.0592C17.4831 14.4734 17.1474 14.8092 16.7331 14.8092H14.8489V16.6932C14.8489 17.1074 14.5131 17.4432 14.0989 17.4432C13.6847 17.4432 13.3489 17.1074 13.3489 16.6932V14.8092H11.3899C10.9757 14.8092 10.6399 14.4734 10.6399 14.0592C10.6399 13.645 10.9757 13.3092 11.3899 13.3092H13.3489V11.35C13.3489 10.9358 13.6847 10.6 14.0989 10.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.f2a90571.svg";
export { ForwardRef as ReactComponent };